(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/footer-closed.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/footer-closed.js');

'use strict';

const {
  useContext,
  useMemo
} = React;
const {
  useSelector
} = ReactRedux;
const formatTime = svs.utils.date.FormatTime;
const {
  drawsApi
} = svs.numbergames.draws;
const {
  ContainerContext
} = svs.numbergames.fractiongames.contexts;
const FooterClosed = React.forwardRef((_, ref) => {
  const {
    selectors
  } = useContext(ContainerContext);
  const productNumeric = useSelector(selectors.selectProductNumeric);
  const isSoldOut = useSelector(selectors.selectIsSoldOut);
  const isClosed = useSelector(selectors.selectIsClosed);
  const nextOpenTime = useMemo(() => {
    const nextOpenTime = drawsApi.nextRegOpenTime(productNumeric);
    if (nextOpenTime) {
      return formatTime(undefined, nextOpenTime);
    }
  }, [productNumeric]);
  return React.createElement("div", {
    className: "ng-fg-footer-closed",
    ref: ref
  }, React.createElement("div", {
    className: "ng-fg-footer-closed-inner"
  }, React.createElement("div", {
    className: "ng-fg-footer-closed-content"
  }, isSoldOut && React.createElement("p", null, "Nytt spel \xF6ppnar alldeles strax!"), isClosed && React.createElement("p", null, "\xD6ppnar f\xF6r f\xF6rs\xE4ljning igen:", React.createElement("br", null), React.createElement("span", null, nextOpenTime)))));
});
svs.numbergames.fractiongames.components.gamecard.FooterClosed = FooterClosed;

 })(window);